import {Card} from "../model/types";
import {useMainWeddingCarousel} from "../model/hooks/useMainWeddingCarousel";
import {MainDiamondCard} from "@/widgets/main-diamonds/ui/MainDiamondCard";
import styles from "./MainWedding.module.scss";

type Props = {
    cards: Card[];
}

export const MainWeddingMobile = ({cards}: Props) => {
    const {carouselRef} = useMainWeddingCarousel(cards.length);
    return (
        <div className={styles.carousel}>
            <div className={`globalContainer`}>
                <div ref={carouselRef} className={styles.carouselViewport}>
                    <div className={styles.carouselContainer}>
                        {cards.map((card) => {
                            return (
                                <MainDiamondCard key={card.link} card={card} className={styles.carouselSlide} />
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
